module.exports = __webpack_public_path__ + "assets/images/4dcb53097908f3f4c719a136cab47b9a.png";